module.exports = __webpack_public_path__ + "img/redBellflower.12121f7f.jpg";